import React, { useCallback } from 'react';
import Icon from '@/components/ui/Icon';
import { LinkButton } from '@/components/ui/Buttons';
import { COLUMN_DEFS } from './columns';
import type { Transaction } from './types';

const escapeCsvValue = (value: unknown): string => {
  if (value == null) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

interface ExportCsvButtonProps {
  data: Transaction[];
  filename: string;
}

const ExportCsvButton = ({ data, filename }: ExportCsvButtonProps) => {
  const exportCsv = useCallback(() => {
    const headerRow = COLUMN_DEFS.map(h => h.label).join(',');
    const dataRows = data.map(row => COLUMN_DEFS.map(h => escapeCsvValue(row[h.key])).join(','));
    const csv = [headerRow, ...dataRows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }, [data, filename]);

  if (data.length === 0) return null;

  return (
    <LinkButton onClick={exportCsv}>
      <Icon fill="currentColor" icon="Download" size={18} />
    </LinkButton>
  );
};

export default ExportCsvButton;
